let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7UJZZ")).then(() => parcelRequire('4534k'));